import type {
  BetterstartPresetDefinition,
  InstalledPresetManifest
} from '@cli-types/preset-engine/presets.js'
import { presetManifestStore } from '@preset-engine/manifests/preset-manifest-store.js'
import { createInstallableRuntime } from '@next-adapter/installable-runtime/create-installable-runtime.js'
import { getIntegrationDefinition } from '@next-adapter/integration-registry.js'
import { getPresetDefinition } from '@next-adapter/preset-registry.js'
import { readPresetTemplate } from '@next-adapter/preset-template-reader/read-preset-template.js'

export const presetFiles = createInstallableRuntime<
  BetterstartPresetDefinition,
  InstalledPresetManifest
>({
  familySegment: 'presets',
  readExtensionTemplate: (presetId, relativePath) => readPresetTemplate(presetId, relativePath),
  getDefinition: (presetId) => getPresetDefinition(presetId),
  getCrossDefinition: (integrationId) => getIntegrationDefinition(integrationId),
  loadManifest: presetManifestStore.load,
  saveManifest: presetManifestStore.save
})
